import { FieldValues, UseControllerProps } from 'react-hook-form';
import {
  TextEditor,
  TextEditorMD,
  TextEditorType,
} from '@wajeez-web/components/ui';

import { TinyMCEFormType } from '../Types';
import { FormInputController } from '../FormInputController';
import {
  convertHtmlToMarkdown,
  convertMarkdownToHtml,
} from '@wajeez-web/core/utils';

export interface FormTextEditorProps<TFormFields extends FieldValues>
  extends UseControllerProps<TFormFields>,
    TextEditorType {
  fieldMeta: TinyMCEFormType;
  validationErrorMessages?: Partial<{
    required: string;
    pattern: string;
    minLength: string;
    maxLength: string;
  }>;
  readOnly?: boolean;
}

export const FormTextEditor = <TFormFields extends FieldValues>({
  name,
  fieldMeta,
  validationErrorMessages,
  readOnly,
  ...props
}: FormTextEditorProps<TFormFields>) => {
  return (
    <FormInputController
      name={name}
      fieldMeta={fieldMeta}
      renderInput={({ ...controllerProps }) => (
        <TextEditorMD
          label={fieldMeta.label}
          placeholder={fieldMeta.placeHolder}
          required={fieldMeta.required}
          {...controllerProps}
          {...props}
        />
      )}
      {...props}
    />
  );
};
